<template>
  <div id="app">
    <app-header></app-header>
    <router-link to="/"></router-link>
    <router-link to="/contact"></router-link>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>
<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default{
  name: 'app',
  components: {
    'app-header': Header,
    'app-footer': Footer
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue